// extracted by mini-css-extract-plugin
module.exports = {"threat_groups":"threat_threat_groups__2mJ65","totals":"threat_totals__2_P9r","tooltip":"threat_tooltip__Ldmnt"};